import { KEY_TAB } from "../_global-variables.js";

let firstElement;
let lastElement;
    
/*
* Config for the focus trap
* @param {array} parents - an array of elements to which the focus should be constrained
* @param {HTMLElement} elementToFocus - an element to focus when the trap is activated.
* Focus trap will be removed from the parent when no elementToFocus is passed
*/
function trapFocus(parents, elementToFocus) {
    // If no elementToFocus is passed, remove all event listeners and get out of here
    if(!elementToFocus) {
        // Trap off. Remove event listeners
        window.removeEventListener("keydown", handleTrapKeydown);
        return;
    }

    let elements = [];
    // Otherwise find all focusable elements inside the parent element passed to this function
    Array.from(parents).forEach(item => {
        elements.push(...getFocusableElements(item));
    });

    firstElement = elements[0];
    lastElement = elements[elements.length - 1];
    // Trap on
    elementToFocus.focus();
    window.addEventListener("keydown", handleTrapKeydown);
}

/* 
* Get focusable elements inside a wrapper
* @param {HTMLElement} element - the wrapper element to be searched through for focusable items
* @returns {array} focusable
*/
function getFocusableElements(element) {
    let focusable = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');        
    // Filter to remove elements that are visually hidden with css
    focusable = Array.from(focusable).filter(item => {
        const computedStyle = window.getComputedStyle(item);
        return computedStyle.display !== "none" && computedStyle.visibility !== "hidden";
    });

    return focusable;
}


/* 
* Keydown event handler for the focus trap
* Checking which key was pressed, handling looping, etc.
*/
function handleTrapKeydown(e) {
    const isTabPressed = (e.key === KEY_TAB);
    if (!isTabPressed) {
        return;
    }
    if (e.shiftKey) {
        if (document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
        }
    } else {
        if (document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
        }
    }
}

export { trapFocus };
